import { action, makeObservable, observable } from 'mobx'

import CalendarViewStore from '~/client/src/shared/stores/ui/CalendarView.store'

import CalendarEvent from '../../../models/CalendarEvent'
import CompaniesStore from '../../../stores/domain/Companies.store'
import ProjectDateStore from '../../../stores/ui/ProjectDate.store'

export default class CalendarPlaceholderStore extends CalendarViewStore {
  @observable public event: CalendarEvent
  @observable private eventDataSnapshot: any

  public constructor(
    projectDateStore: ProjectDateStore,
    companiesStore: CompaniesStore,
    isPreviewMode?: boolean,
  ) {
    super(projectDateStore, companiesStore, isPreviewMode)

    makeObservable(this)
  }

  public get eventPlaceholder(): CalendarEvent {
    return this.event
  }

  @action.bound
  public setEventPlaceholder(event: CalendarEvent) {
    this.event = event
  }

  @action.bound
  public resetEventPlaceholder() {
    this.event = null
    this.eventDataSnapshot = null
  }

  @action.bound
  public setEventPlaceholderTime(
    startTime: Date,
    endTime: Date,
    isAllDay?: boolean,
  ) {
    this.event.startDate = startTime
    this.event.endDate = endTime
    this.event.isAllDay = isAllDay
  }

  @action.bound
  public setEventPlaceholderZone(zoneId: string) {
    this.event.zoneId = zoneId
  }

  @action.bound
  public setDraftEventData(event: any) {
    this.eventDataSnapshot = event
  }

  public get draftEventData(): any {
    return this.eventDataSnapshot
  }
}
